<script lang="ts">
	import ImageOptimiser from '$lib/components/common/ImageOptimiser.svelte';
	import { page } from '$app/stores';
	import { pushState } from '$app/navigation';
	import SlideModal from '$ravioli/lib/components/SlideModal.svelte';

	// images
	import homeIcon from '$ravioli/lib/assets/icons/home.svg';
	import aboutIcon from '$ravioli/lib/assets/icons/doc.svg';
	import contactIcon from '$ravioli/lib/assets/icons/contact.svg';
	import profileIcon from '$ravioli/lib/assets/icons/nav-profile.svg';
	import faqIcon from '$ravioli/lib/assets/icons/faq.svg';
	import logo from '$ravioli/lib/assets/images/logo.png';
	import closeIcon from '$ravioli/lib/assets/icons/close.svg';
	import menuIcon from '$ravioli/lib/assets/icons/hamburger-menu.svg';
	import profileIconPc from '$ravioli/lib/assets/icons/profile.svg';

	let navlinks = [
		{
			name: 'Home',
			link: '/',
			icon: homeIcon
		},
		{
			name: 'About Us',
			link: '/about-us',
			icon: aboutIcon
		},
		{
			name: 'Contact Us',
			link: '/contact-us',
			icon: contactIcon
		},
		{
			name: 'FAQs',
			link: '/faqs',
			icon: faqIcon
		},
		{
			name: 'Profile',
			link: '/apex/account',
			icon: profileIcon
		}
	];

	const showModal = () => {
		pushState('', {
			showSlideDownModal: { menu: true }
		});
	};

	const closeModal = () => {
		history.back();
	};
</script>

<SlideModal id="menu" on:click={closeModal}>
	<div slot="content">
		<div class=" items-starts flex flex-col justify-start text-center">
			{#each navlinks as item}
				<a
					href={item.link}
					class="link-before flex h-[58px] cursor-pointer items-center justify-start gap-2 pl-6 hover:bg-[#FCF6ED]"
					class:link-active={$page.url.pathname === item.link}
				>
					<img src={item.icon} alt={item.name} />
					{item.name}
				</a>
			{/each}
		</div>
	</div>
</SlideModal>

<div class="font-roboto fixed left-0 right-0 top-0 z-40 bg-white shadow-[0px_2px_12px_0px_rgba(0,_0,_0,_0.04)]">
	<div
		class=" z-40 mx-auto flex max-w-screen-2xl items-center justify-between px-6 pb-3 pt-5 md:px-20 md:py-7"
	>
		<a href="/" class="max-w-20 md:max-w-[112px]">
			<ImageOptimiser src={logo} alt="logo" imageSourceType="internal" classes={{ container: 'w-20 h-[30px] md:w-28 md:h-[42px]', image: 'w-full h-full object-cover' }} />
		</a>

		{#if $page.state.showSlideDownModal && $page.state.showSlideDownModal.menu}
			<button
				on:click={closeModal}
				class="font-roboto flex items-center gap-2 text-base font-normal text-[#3B6457] md:hidden"
			>
				<img src={closeIcon} alt="" />
			</button>
		{:else}
			<button
				on:click={showModal}
				class="font-roboto flex items-center gap-2 text-base font-normal text-[#3B6457] md:hidden"
			>
				<img src={menuIcon} alt="" />
			</button>
		{/if}
		<div class="hidden items-center gap-6 md:flex">
			{#each navlinks.slice(0, 4) as item}
				<a
					class="font-roboto text-center text-base font-medium text-[#837c7c]"
					href={item.link}
					class:active={$page.url.pathname === item.link}
				>
					{item.name}
				</a>
			{/each}
		</div>
		<div class="text-iris_primary hidden items-center gap-2 md:flex">
			<a class="flex items-center justify-center gap-2" href="/apex/account">
				<img src={profileIconPc} alt="profile" />
				<p class="text-xl font-medium text-[#837C7C]">Profile</p>
			</a>
		</div>
	</div>
</div>

<style>
	.active {
		color: #ed292d;
		font-weight: bold;
		text-decoration: underline;
		text-underline-offset: 8px;
		text-decoration-color: #ed292d;
	}
	.link-active.link-before::before,
	.link-before:hover::before {
		opacity: 1;
	}
	.link-active {
		background-color: #fcf6ed;
	}
	.link-before::before {
		content: '';
		position: fixed;
		opacity: 0;
		left: 0px;
		height: 58px;
		width: 5.44px;
		background-color: #ed292d;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
	}
</style>
